import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.6668 5L7.50016 14.1667L3.3335 10", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCheck;
